import * as CONFIGS from '@/statics/configs.js'

const NODE11 = {
  NAME: 'SP-TE10',
  INPUT1: {
    NAME: 'NODE2_INPUT1_NAME',
    TYPE: 'zeroContact',
    ICON: 'switch',
    PARAMETER_ID: 0x8020,
  },
  OUTPUT1: {
    NAME: 'NODE2_OUTPUT1_NAME',
    TYPE: 'RelaySSR2A',
    ICON: 'lamp',
    PARAMETER_ID: 0xE010,
  },
  TEMPERATURE: {
    NAME: 'NODE2_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  OUTPUT2: {
    NAME: 'NODE9_OUTPUT1_NAME',
    TYPE: 'rgb',
    ICON: 'rgb',
    PARAMETER_ID: 0,
  },
  OUTPUT3: {
    NAME: 'NODE9_OUTPUT2_NAME',
    TYPE: 'colorPwm',
    ICON: 'red',
    PARAMETER_ID: 0,
  },
  OUTPUT4: {
    NAME: 'NODE9_OUTPUT3_NAME',
    TYPE: 'colorPwm',
    ICON: 'green',
    PARAMETER_ID: 0,
  },
  OUTPUT5: {
    NAME: 'NODE9_OUTPUT4_NAME',
    TYPE: 'colorPwm',
    ICON: 'blue',
    PARAMETER_ID: 0,
  },
  HUE: {
    PARAMETER_ID: 0xE130,
  },
  SATURATION: {
    PARAMETER_ID: 0xE131,
  },
  BRIGHTNESS: {
    PARAMETER_ID: 0xE132,
  },
  RANDOM_COLOR: {
    PARAMETER_ID: 0x6030,
  },
  FADE_TIME: {
    PARAMETER_ID: 0xE140,
  },
  ANIMATION_MODE: {
    PARAMETER_ID: 0xE141,
  },
  HUE_ONOFF_CONFIG :{
    PARAMETER_ID: 0xE220,
  },
  SATURATION_ONOFF_CONFIG :{
    PARAMETER_ID: 0xE221,
  },
  BRIGHTNESS_ONOFF_CONFIG :{
    PARAMETER_ID: 0xE222,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
  RELAY_INIT_CONFIG: {
    PARAMETER_ID: 0xE110,
  }
}
NODE11.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE11.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE11.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE11.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE11.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE11.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE11.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
  ],
]

export default NODE11;